import * as Yup from "yup";
import { useFormik } from "formik";
import React, { useState } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "pages/components/LayoutContainers/DashboardLayout";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import DashboardNavbar from "pages/DashboardNavbar";
import KendoInput from "assets/theme/components/inputKendo";
import KendoButton from "assets/theme/components/button/kendo";
import FormField from "pages/components/FormField";
import { AssetService } from "api/users.api";
import toast from "react-hot-toast";
import { useNavigate, Link } from "react-router-dom";
import ImagesUpload from "./components/ImagesUpload";
import DocumentsUpload from "./components/DocumentsUpload";

function AddVendor() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    vendorName: Yup.string()
      .required("This field is required")
      .max(50, "Enter maximum 40 characters"),
    contactNumber: Yup.string()
      .required("This field is required")
      .matches(/^\d{10}$/, "Enter a valid 10-digit phone number"),
    contactEmail: Yup.string()
      .required("This field is required")
      .email("Enter a valid email address"),
    vendorType: Yup.string().required("This field is required"),
    description: Yup.string().max(250, "Enter maximum 250 characters"),
    images: Yup.array(),
    files: Yup.array(),
  });

  const formik = useFormik({
    initialValues: {
      vendorName: "",
      vendorType: "",
      contactNumber: "",
      contactEmail: "",
      description: "",
      images: [],
      files: [],
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = new FormData();
      body.append("description", values.description);
      body.append("notes", values.notes);

      if (values?.images && values?.images?.length > 0) {
        values.images.forEach((item, i) => {
          body.append("images", values.images[i].file);
        });
      }

      if (values?.files && values?.files?.length > 0) {
        values.files.forEach((item, i) => {
          body.append("documents", values.files[i].file);
        });
      }
      addDeviceAsset(body);
    },
  });

  const addDeviceAsset = async (formData) => {
    try {
      setLoading(true);
      const response = await AssetService.createDevice(formData);
      console.log(response);
      toast.success("Asset saved successfully");
      navigate(`/device/checkout?d=${response?.data?.data?.deviceNumber}`);
    } catch (error) {
      console.error(error);
      if (!!error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error(error?.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = (uploadedImages) => {
    formik.setFieldValue("images", uploadedImages);
  };

  const handleDocumentUpload = (uploadFiles) => {
    formik.setFieldValue("files", uploadFiles);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <SoftBox mb={3}>
              <Grid item xs={12} md={12} lg={12}>
                <Link to={""}>
                  <SoftTypography
                    variant="h5"
                    fontSize="medium"
                    mb={2}
                    component="a"
                    onClick={() => navigate(-1)}
                    display="flex"
                    alignItems="center"
                    color="info"
                  >
                    <KeyboardBackspaceIcon fontSize="medium" sx={{ mr: 0.5 }} /> Go Back
                  </SoftTypography>
                </Link>
                <Card id="add-assets" sx={{ overflow: "visible" }}>
                  <SoftBox p={3}>
                    <SoftTypography variant="h5">Vendor Details</SoftTypography>
                  </SoftBox>
                  <SoftBox component="form" pb={3} px={3} onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2}>
                      <Grid item sx={12} md={12} lg={6}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={12} lg={12}>
                            <SoftTypography
                              fontSize="small"
                              fontWeight="bold"
                              letterSpacing={0.3}
                              variant="h5"
                              mb={0.5}
                            >
                              Vendor Name
                            </SoftTypography>
                            <KendoInput
                              placeholder="Enter vendor name"
                              name="vendorName"
                              value={formik.values.vendorName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.vendorName && formik.errors.vendorName ? (
                              <div className="form-error error">{formik.errors.vendorName}</div>
                            ) : null}
                          </Grid>
                          <Grid item xs={12} md={12} lg={12}>
                            <SoftTypography
                              fontSize="small"
                              fontWeight="bold"
                              letterSpacing={0.3}
                              variant="h5"
                              mb={0.5}
                            >
                              Contact number
                            </SoftTypography>
                            <KendoInput
                              placeholder="Enter phone number"
                              name="contactNumber"
                              value={formik.values.contactNumber}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.contactNumber && formik.errors.contactNumber ? (
                              <div className="form-error error">{formik.errors.contactNumber}</div>
                            ) : null}
                          </Grid>
                          <Grid item xs={12} md={12} lg={12}>
                            <SoftTypography
                              fontSize="small"
                              fontWeight="bold"
                              letterSpacing={0.3}
                              variant="h5"
                              mb={0.5}
                            >
                              Contact Email
                            </SoftTypography>
                            <KendoInput
                              placeholder="Enter email"
                              name="contactEmail"
                              value={formik.values.contactEmail}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.contactEmail && formik.errors.contactEmail ? (
                              <div className="form-error error">{formik.errors.contactEmail}</div>
                            ) : null}
                          </Grid>

                          <Grid item xs={12} md={12} lg={12}>
                            <SoftTypography
                              fontSize="small"
                              fontWeight="bold"
                              letterSpacing={0.3}
                              variant="h5"
                              mb={0.5}
                            >
                              Vendor type
                            </SoftTypography>
                            <select name="assetCategory" className="custom-select">
                              <option value="1">Ram Singh</option>
                              <option value="2">Pankaj Singh</option>
                              <option value="3">John Doue</option>
                            </select>
                          </Grid>

                          <Grid item xs={12} md={12} lg={12} paddingLeft={2} pt={0.5}>
                            <FormField
                              placeholder="type your message..."
                              name="description"
                              label="Description"
                              value={formik.values.description}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              multiline
                              rows={4}
                            />
                            {formik.touched.description && formik.errors.description ? (
                              <div className="form-error error">{formik.errors.description}</div>
                            ) : null}
                          </Grid>
                          <Grid item xs={12} md={12} lg={12} paddingLeft={2}>
                            <ImagesUpload handleImageUpload={handleImageUpload} />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item sx={12} md={12} lg={6}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={12} lg={12} paddingLeft={2} pt={3}>
                            <DocumentsUpload handleDocumentUpload={handleDocumentUpload} />
                          </Grid>
                        </Grid>
                      </Grid>
                      <SoftBox ml={2} mt={2}>
                        <KendoButton type="submit" label={"Submit"} loading={loading} />
                      </SoftBox>
                    </Grid>
                  </SoftBox>
                </Card>
              </Grid>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
}

export default AddVendor;
